module.exports = __webpack_public_path__ + "static/media/empty-cart.57a7924b.svg";